import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

export default class KickOffPenaltyDeclined extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const nextFragment = play.getNextFragment(fragment);
        return (
            nextFragment.associatedState === FootballState.KickOffPenalty &&
            play.getNextFragment(nextFragment).associatedState ===
                FootballState.KickOffPenaltyDeclined
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const penaltyDeclinedFragment = play.getFirstFragment(
            FootballState.KickOffPenaltyDeclined
        );
        const kickingTeamHasPossession =
            penaltyDeclinedFragment.team.id === gameContext.kickingOffTeamId;
        gameContext.setPossessionForTeamId(penaltyDeclinedFragment.team.id);
        gameContext.triggerKO = kickingTeamHasPossession;
        gameContext.setDriveContext({
            triggerDrive: !kickingTeamHasPossession
        });
        gameContext.setFieldPosition(penaltyDeclinedFragment.fieldPosition);
    }
}
